export default __webpack_public_path__ + "static/media/WATCH-BNB-APE.604d64b9.svg";